import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import HelperService from '../../services/HelperService';
import { appSlice } from '../../store/slices';
import Icon, { Icons } from '../Icon/Icon';
import './AMLDetailList.scss';

const AMLDetailList = ({
	amlDetailsListHeader = ['Signal', 'Volume', 'Amount'],
	amlDetailsList = [{ id: 1, title: 'Sanctions', volume: 0.19, amount: 199.9, color: 'red' }],
	isLoading = false,
	showIcon = true,
	canRowClick = false,
}) => {
	const dispatch = useDispatch();

	const onRowClick = row => {
		if (!canRowClick) return;

		dispatch(
			appSlice.actions.addModal({
				title: row.title,
				tag: 'AMLDetailsModal',
				isOpen: true,
				height: '80%',
				outsideParams: { list: row.counterparties },
			})
		);
	};

	return (
		<div className='AMLDetailList'>
			<div className='AMLDetailList_header'>
				{amlDetailsListHeader.map((item, index) => (
					<div key={index} className={`AMLDetailList_header_cell_${index + 1}`}>
						{item}
					</div>
				))}
			</div>
			<div className='AMLDetailList_body'>
				{amlDetailsList.map((item, index) => (
					<div key={index} className='AMLDetailList_body_row' onClick={() => onRowClick(item)}>
						{isLoading ? (
							<div className='AMLDetailList_body_row_loading' />
						) : (
							<>
								<div className='AMLDetailList_body_row_container'>
									<span className='AMLDetailList_body_row_container_cell_1'>{item.title}</span>
									<span
										className={classNames(
											'AMLDetailList_body_row_container_cell_2',
											`AMLDetailList_body_row_container_cell_2_${item.color}`
										)}
									>
										{item.percent}%
									</span>
									<span className='AMLDetailList_body_row_container_cell_3'>
										{HelperService.formatCompactNumber?.(item.amount, { decimals: 1 }) ?? '-'}
									</span>
								</div>
								{showIcon && (
									<div className='AMLDetailList_body_row_icon'>
										<Icon type={Icons.CHEVRON} />
									</div>
								)}
							</>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default AMLDetailList;
